// @ngInject
function OrderTypesApiService(ResourcesService) {

  var endpoint = 'ordertypes';

  return {
    getOrderTypes: ResourcesService.apiFactory.get(endpoint),
    getOrderType: ResourcesService.apiFactory.get(endpoint),
    getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
    getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
    getPrintDocumentTemplates: ResourcesService.apiFactory.get(endpoint + '/printDocumentTemplates'),
    getDeliveryPlanningTemplates: ResourcesService.apiFactory.get(endpoint + '/deliveryPlanningTemplates'),
    createOrderType: ResourcesService.apiFactory.create(endpoint, 'OrderType'),
    updateOrderType: ResourcesService.apiFactory.update(endpoint, 'OrderType'),
    deleteOrderType: ResourcesService.apiFactory.delete(endpoint, 'OrderType')
  };
}

angular
  .module('ordertypes.api', [])
  .factory('OrderTypesApiService', OrderTypesApiService);
